var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5C9.32843 14.5 10 15.1716 10 16C10 16.8284 9.32843 17.5 8.5 17.5C7.67157 17.5 7 16.8284 7 16C7 15.1716 7.67157 14.5 8.5 14.5ZM15.5 14.5C16.3284 14.5 17 15.1716 17 16C17 16.8284 16.3284 17.5 15.5 17.5C14.6716 17.5 14 16.8284 14 16C14 15.1716 14.6716 14.5 15.5 14.5ZM1.5 14.5C2.32843 14.5 3 15.1716 3 16C3 16.8284 2.32843 17.5 1.5 17.5C0.671573 17.5 0 16.8284 0 16C0 15.1716 0.671573 14.5 1.5 14.5ZM8.5 7.5C9.32843 7.5 10 8.17157 10 9C10 9.82843 9.32843 10.5 8.5 10.5C7.67157 10.5 7 9.82843 7 9C7 8.17157 7.67157 7.5 8.5 7.5ZM15.5 7.5C16.3284 7.5 17 8.17157 17 9C17 9.82843 16.3284 10.5 15.5 10.5C14.6716 10.5 14 9.82843 14 9C14 8.17157 14.6716 7.5 15.5 7.5ZM1.5 7.5C2.32843 7.5 3 8.17157 3 9C3 9.82843 2.32843 10.5 1.5 10.5C0.671573 10.5 0 9.82843 0 9C0 8.17157 0.671573 7.5 1.5 7.5ZM8.5 0.5C9.32843 0.5 10 1.17157 10 2C10 2.82843 9.32843 3.5 8.5 3.5C7.67157 3.5 7 2.82843 7 2C7 1.17157 7.67157 0.5 8.5 0.5ZM15.5 0.5C16.3284 0.5 17 1.17157 17 2C17 2.82843 16.3284 3.5 15.5 3.5C14.6716 3.5 14 2.82843 14 2C14 1.17157 14.6716 0.5 15.5 0.5ZM1.5 0.5C2.32843 0.5 3 1.17157 3 2C3 2.82843 2.32843 3.5 1.5 3.5C0.671573 3.5 0 2.82843 0 2C0 1.17157 0.671573 0.5 1.5 0.5Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBar);
export default __webpack_public_path__ + "static/media/MenuBar.c11dc2a932713c7f92d790622c25e26d.svg";
export { ForwardRef as ReactComponent };